/**
 * IndexedDB (via `idb`) — replaces the prototype's `localStorage`.
 * See .claude/skills/farmer-offline-sync/SKILL.md §2. Phương án A (ADR-6): tolerate brief
 * connectivity loss, not full offline-first. Do NOT add a Service Worker / PWA manifest
 * here — that is Phương án B, explicitly not approved for this phase.
 */
import { openDB } from 'idb';

const DB_NAME = 'farmer-survey';
const DB_VERSION = 1;

let dbPromise = null;

export function getDb() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(d) {
        // Current draft answers per submission — source of truth when offline.
        if (!d.objectStoreNames.contains('drafts')) {
          d.createObjectStore('drafts', { keyPath: 'submissionId' });
        }
        // Queue of write requests that couldn't be sent yet.
        if (!d.objectStoreNames.contains('queue')) {
          const q = d.createObjectStore('queue', { keyPath: 'id', autoIncrement: true });
          q.createIndex('bySubmission', 'submissionId');
        }
        // Read cache: form schema (immutable per version), recently viewed households, etc.
        if (!d.objectStoreNames.contains('cache')) {
          d.createObjectStore('cache');
        }
        // NOTE: never drop 'drafts' or 'queue' here on future version bumps — that data
        // may be an enumerator's unsynced interview.
      },
    });
  }
  return dbPromise;
}

export async function saveDraft(submissionId, draft) {
  const db = await getDb();
  await db.put('drafts', { submissionId, ...draft, savedAt: new Date().toISOString() });
}

export async function loadDraft(submissionId) {
  const db = await getDb();
  return db.get('drafts', submissionId);
}

export async function deleteDraft(submissionId) {
  const db = await getDb();
  await db.delete('drafts', submissionId);
}

export async function cacheGet(key) {
  const db = await getDb();
  return db.get('cache', key);
}

export async function cacheSet(key, value) {
  const db = await getDb();
  await db.put('cache', value, key);
}
